import React from 'react';

import { Label } from '@admin/components/helpers/label';
import { ACCOUNT_STATE_TO_KIND, ACCOUNT_STATE_TO_NAME } from '@admin/constants/account_state';
import { Account } from '@admin/schema';

export const State: React.FC<{
  account: Pick<Account, 'state'> | { state: 'active' | 'pending' | 'canceled' | 'suspended' };
}> = ({ account: { state } }) => <Label kind={ACCOUNT_STATE_TO_KIND[state]}>{ACCOUNT_STATE_TO_NAME[state]}</Label>;
